// Accessibility enhancements for Nouvel Heritage Paris theme
document.addEventListener("DOMContentLoaded", () => {
//   setTimeout(() => {

    function checkFocus() {
        document.addEventListener("focusin", function(e){
        console.log("Focused element:", e.target);
        });
    }

    function addAttributesByClass(className, attributes = {}) {
        const elements = document.querySelectorAll(className);

        elements.forEach(el => {
            for (let attr in attributes) {
                el.setAttribute(attr, attributes[attr]);
            }
        });
    }

    function renameElementTag(oldElementsInput, newTagName) {
        const oldElements = Array.isArray(oldElementsInput)? oldElementsInput : [oldElementsInput];
        const newElements = [];
        oldElements.forEach(oldElement => {
            if (!oldElement || !oldElement.parentNode) return;
            const newElement = document.createElement(newTagName);
            // copy attributes
            Array.from(oldElement.attributes).forEach(attr => {newElement.setAttribute(attr.name, attr.value);});
            // move children
            while (oldElement.firstChild) {
            newElement.appendChild(oldElement.firstChild);
            }
            // replace in DOM
            oldElement.parentNode.replaceChild(newElement, oldElement);
            newElements.push(newElement);
        });
        // single element দিলে single element return
        return newElements.length === 1 ? newElements[0] : newElements;
    }

    function wrightHeadingH2() {
        const wrongHeadingH3 = document.querySelectorAll('.shopify-block rte-formatter h3');
        if (wrongHeadingH3 && wrongHeadingH3.length > 0) {
            wrongHeadingH3.forEach((heading) => {
                heading.setAttribute('aria-level', '2');
            });
        }
    }

    function processTable(table, tableIndex) {
        if (table.dataset.accessibilityProcessed === "true") return;
        table.dataset.accessibilityProcessed = "true";

        table.setAttribute("role", "table");

        let thead = table.querySelector("thead");
        let tbody = table.querySelector("tbody");

        if (!tbody) return;

        const rows = Array.from(tbody.querySelectorAll("tr"));
        if (!rows.length) return;

        if (!thead) {
        thead = document.createElement("thead");
        table.insertBefore(thead, tbody);

        const headerRow = rows.shift();
        thead.appendChild(headerRow);
        }

        const headerCells = Array.from(
        thead.querySelectorAll("tr:first-child > *")
        );

        /* ============================
        2. Convert headers to <th>
        ============================ */
        headerCells.forEach((cell, index) => {
        let th = cell;

        if (cell.tagName.toLowerCase() !== "th") {
            th = document.createElement("th");
            th.innerHTML = cell.innerHTML;

            [...cell.attributes].forEach(attr =>
            th.setAttribute(attr.name, attr.value)
            );

            cell.replaceWith(th);
        }

        th.setAttribute("scope", "col");
        th.setAttribute("id", `table-${tableIndex}-header-${index}`);
        });

        /* ============================
        3. Apply headers to TDs
        ============================ */
        Array.from(tbody.querySelectorAll("tr")).forEach(row => {
        Array.from(row.children).forEach((cell, index) => {
            if (cell.tagName.toLowerCase() === "td") {
            cell.setAttribute(
                "headers",
                `table-${tableIndex}-header-${index}`
            );
            }
        });
        });
    }

    function addLinkAria(link) {
        if (link && link.hasAttribute('href')) {
            let labelText = '';
            if (!labelText) {
            const href = link.getAttribute('href');
            if (!href) return;

            const path = href.split('?')[0].replace(/^\/|\/$/g, '');
            const parts = path.split('/'); // ["collections", "brunch-in-ny-mood"]

            if (parts.length >= 3) {
                const section = parts[0]
                .replace(/[-_]/g, ' ')
                .replace(/\b\w/g, c => c.toUpperCase());

                const slug = parts[1]
                .replace(/[-_]/g, ' ')
                .replace(/\b\w/g, c => c.toUpperCase());

                const frslug = parts[2]
                .replace(/[-_]/g, ' ')
                .replace(/\b\w/g, c => c.toUpperCase());

                labelText = window.location.href.includes('fr') ? `View ${slug} to ${frslug}` : `View ${section} to ${slug}`;
            }
            }
            if (labelText) {
            link.setAttribute('aria-label', labelText);
            }
        }
    }


    // issu 3
    addAttributesByClass('.header__column .header-logo__image', {alt : 'Nouvel Heritage Paris Logo'});

    // isssu 4

    
    const headerMenu = document.querySelectorAll('.mega-menu__list.list-unstyled');
    headerMenu.forEach((el, index) => {
    if (index === 3 || index === 4) {
       // console.log(el);
        const menuLibefore = el.querySelector('li.mega-menu__column.mega-menu__column--span-1');
        const menuLiAfter = el.querySelectorAll('li.mega-menu__column.mega-menu__column--span-1 > div');
        el.setAttribute('role', 'presentation');
        menuLibefore.setAttribute('role', 'list');
        menuLiAfter.forEach((item) => {
            item.setAttribute('role', 'listitem');
        });

       // console.log( menuLibefore);
    }
    });

    // issue 15  // issue 16
    const main_section_content = document.querySelectorAll('.group-block-content.layout-panel-flex');

if (main_section_content.length > 0) {
    main_section_content.forEach((child, index) => {

        const childH2 = child.querySelector('.findH2 h2, .findH2 h3, .findH2 p');
        const childA = child.querySelector('a.size-style.button-secondary');
        const childImg = child.querySelector('img');
        if (childH2 && childA && childImg) {
            childA.setAttribute(
                'aria-label',
                `${childA.textContent.trim()} Of ${childH2.textContent.trim()}`
            );

            if (!childImg.getAttribute('alt')) {
                childImg.setAttribute(
                    'alt',
                    `${childH2.textContent.trim()} Image`
                );
            }
        }

        const video = child.querySelector('video');
        if (video && childH2 && video.hasAttribute('poster')) {
            const videoImg = video.querySelector('img');
            videoImg.setAttribute(
                'aria-label',
                `${childH2.textContent.trim()} Video Thumbnail`
            );
        }

        const link = child.querySelector('a.image-block');
        if (typeof addLinkAria === 'function' && link) {
            addLinkAria(link);
        }

        const viewAll = child.querySelector('.section-resource-list__header a[href="/collections/all"], .section-resource-list__header a[href="/fr/collections/all"]');
        const viewHead = child.querySelector('.section-resource-list__header .findH2 h3, .section-resource-list__header .findH2 p');
       // console.log(viewAll)
        if (viewAll && viewHead) {
            viewAll.setAttribute(
                'aria-label',
                `${viewAll.textContent.trim()} ${viewHead.textContent.trim()} Collections`)
        }

    });
}


    // issu 19
    const footerSum = document.querySelectorAll('#footer-group .menu__heading.h4');
    if (footerSum) {
        footerSum.forEach(sum => {
        sum.setAttribute('tabindex', '-1');  
    });
    }

    // issue 21
    const footerH3 = document.querySelector('#footer-group .findH2 h3, #footer-group .findH2 p');
    if (footerH3) {
        footerH3.style.color = '#D23F61';
        renameElementTag(footerH3, 'p');
    }
    
    // issue 32
    const blogPostContent = document.querySelectorAll('.blog-posts-container .blog-post-item');
    if (blogPostContent && blogPostContent.length > 0) {
      //  console.log(blogPostContent);
        blogPostContent.forEach(blogPostCon => {
            const blogHeading = blogPostCon.querySelector('.blog-post-card__content a > div');
            const blogReadMore = blogPostCon.querySelector('rte-formatter a');
            blogReadMore.setAttribute('aria-label', 'Read more about ' + blogHeading.textContent.trim());
            renameElementTag(blogHeading, 'h2');
            
        });
    }
    
    // issue 34
    function headingChangeDf(el) {
        const blogPostsH2 = el
        if (blogPostsH2 && blogPostsH2.length > 0) {
           // console.log(blogPostsH2);
            renameElementTag(blogPostsH2[0], 'h1');
        }
    }
    headingChangeDf(document.querySelectorAll('.blog-posts .findH2 p'));
    headingChangeDf(document.querySelectorAll('header .findH2 > p'));

    if (window.location.href.includes("blogs/in-conversation/10-years-of-nouvel-heritage") || window.location.href.includes('blogs/echanges-inspirants/10-years-of-nouvel-heritage')) {
        const YearsNH = document.querySelector('rte-formatter h2');
        const YearsNH2 = document.querySelector('rte-formatter h5');
        console.log(YearsNH, YearsNH2);
        if (YearsNH && YearsNH2) {
            YearsNH2.setAttribute('aria-level', '2');
            YearsNH.setAttribute('aria-level', '1');
        }
    }
    
    // issue 43
    if (window.location.href.includes('collections/all')) {
        const discover = document.querySelector('.group-block-content a.size-style')
       // console.log(discover);
        if (discover) {
            const disHeading = document.querySelector('.findH2.h6 p')
            discover.setAttribute('aria-label', `${discover.textContent.trim()} ${disHeading.textContent.trim()}`);
        }
        // issue 46
        const headingFirst = document.querySelector('.media-with-content .findH2 p')
        if (headingFirst) {
            renameElementTag(headingFirst, 'h1');
        }
    }

    // issue 47
    if (window.location.href.includes('pages/warranty') || window.location.href.includes('fr/pages/garantie')) {
        const blogContenet = document.querySelectorAll('.shopify-block rte-formatter')[0];
        if (blogContenet) {
           // console.log(blogContenet.children);
            const blogHeadings = blogContenet.querySelectorAll('h4');
            blogHeadings.forEach((heading, index) => {
                heading.setAttribute('aria-level', '2');
               // heading.setAttribute('role', 'heading');
            });
        }
        const findHeading = document.querySelector('.findH2.text-block.h2 p');
        if (findHeading) {
            renameElementTag(findHeading, 'h2');
        }
        const wrongHeading = document.querySelectorAll('.findH2.text-block.h4 h2');
        if (wrongHeading && wrongHeading.length > 0) {
            wrongHeading.forEach((heading) => {
                renameElementTag(heading, 'p');
            });
        }
    }

    // issue 48
    if (window.location.href.includes('pages/our-locations')) {
        const wrongHeadingH6 = document.querySelectorAll('.findH2.text-block.rte h6');
        if (wrongHeadingH6 && wrongHeadingH6.length > 0) {
            wrongHeadingH6.forEach((heading) => {
                renameElementTag(heading, 'h5');
            });
        }
    }

    // issue 50
    if (window.location.href.includes('pages/inside-nh')) {
        const MainContent = document.querySelectorAll('#MainContent > div.shopify-section');
        if (MainContent && MainContent.length > 0) {
            MainContent.forEach((content) => {
                const headingH2 = content.querySelector('.findH2.text-block.h3 p');
                if (headingH2) {
                    renameElementTag(headingH2, 'h2');
                }
            });
        }
        const heroImg = document.querySelector('.hero__media-wrapper img');
        if (heroImg) {
            heroImg.setAttribute('alt', "A close-up view shows a craftsman's hands polishing a gleaming gold bracelet on a spinning buffing wheel.");
        }
    }

    // issue 52
    if (window.location.href.includes('pages/privacy-policy')) {
        const wrongLink = document.querySelectorAll('.group-block-content a[href="/collections/dinner-date-mood"].image-block');
        if (wrongLink && wrongLink.length > 0) {
            wrongLink.forEach((link) => {
                link.removeAttribute('href');
                renameElementTag(link, 'div');
            });
        }
        const frHeadingH2 = document.querySelectorAll('.shopify-section .c-richtext.t-text h3');
        if (frHeadingH2 && frHeadingH2.length > 0) {
            frHeadingH2.forEach((frH) => {
                frH.setAttribute('aria-level', '2');
            });
        }
    }
    

    // issue 54
    if (window.location.href.includes('pages/bangles-size-guide')) {
        wrightHeadingH2();
        // issue 56
        const tableP = document.querySelectorAll('.rte-table-wrapper table thead p');
        if (tableP) {
            tableP.forEach(p => {
            if (p.querySelector('abbr')) return;
            const text = p.innerHTML;
            if (text.includes('(cm)')) {
            p.innerHTML = text.replace('(cm)','(<abbr title="centimetres">cm</abbr>)');
            }
        });
        }
    }

    // issue 55
    const hrLines = document.querySelectorAll('hr');
    if (hrLines && hrLines.length > 0) {
        hrLines.forEach((hr) => {
            hr.setAttribute('aria-hidden', 'true');
        });
    }

    // issue 57
    const moodHeading = document.querySelectorAll('.findH2.text-block.h2 > p');
    if (moodHeading && moodHeading.length > 0) {
        moodHeading.forEach((heading) => {
            renameElementTag(heading, 'h2');
        });
    }

    if (window.location.href.includes('pages/ring-size-guide')) {
        wrightHeadingH2();
        const wrongHeadingp = document.querySelector('.shopify-block rte-formatter p');
        if (wrongHeadingp) {
            wrongHeadingp.setAttribute('aria-level', '2');
            wrongHeadingp.setAttribute('role', 'heading');
        }
    }

    // issue 59
    const table = document.querySelectorAll(".rte-table-wrapper table")
    if (table && table.length > 0) {
        table.forEach(processTable);
    }

    // issue 60
    if (window.location.href.includes('pages/faqs')) {
        const clickHereLinks = document.querySelectorAll('a[href="https://nouvelheritage.returnscenter.com/"]');
        if (clickHereLinks && clickHereLinks.length > 0) {
            clickHereLinks.forEach((link) => {
                link.setAttribute('aria-label', window.location.href.includes('fr') ? 'Cliquez ici pour revenir à la page du Centre de retours Nouvel Heritage (ouvre dans un nouvel onglet).' : 'Click here to return to Nouvel Heritage Returns Center page Opens in a new tab');
            });
        }
        const reviewLinnk = document.querySelector('a[href="https://us.nouvelheritage.com/pages/bangles-size-guide"], a[href="https://us.nouvelheritage.com/fr/pages/bangles-size-guide"]');
        const ringSizeLink = document.querySelector('a[href="https://us.nouvelheritage.com/pages/ring-size-guide"], a[href="https://us.nouvelheritage.com/fr/pages/ring-size-guide"]');
        if (reviewLinnk && ringSizeLink) {
            reviewLinnk.setAttribute('aria-label', window.location.href.includes('fr') ? 'Cliquez ici pour consulter notre guide des tailles de bracelets (ouvre dans un nouvel onglet).' : 'Click here to Review our Bangles Size Guide page Opens in a new tab');
            ringSizeLink.setAttribute('aria-label', window.location.href.includes('fr') ? 'Cliquez ici pour consulter notre guide des tailles de bagues (ouvre dans un nouvel onglet).' : 'Click here to Review our Ring Size Guide page Opens in a new tab');
        }
        const ReadMorePolicy = document.querySelector('a[href="https://us.nouvelheritage.com/pages/refund-policy"], a[href="https://us.nouvelheritage.com/fr/pages/refund-policy"]');
        if (ReadMorePolicy) {
            ReadMorePolicy.setAttribute('aria-label', window.location.href.includes('fr') ? 'Pour en savoir plus sur notre politique de remboursement, cliquez ici (ouvre dans un nouvel onglet).' : 'Read more about Refund Policy Opens in a new tab');
        }
        const wrongHeadingH1 = document.querySelector('.findH2 h3');
        const wrongHeadingH2 = document.querySelector('.findH2 h4');
        if (wrongHeadingH1 && wrongHeadingH2) {
            wrongHeadingH1.setAttribute('aria-level', '1');
            wrongHeadingH2.setAttribute('aria-level', '2');
        }
    }

    // issue 66 last check
    const blogPostCard = document.querySelectorAll('.blog-post-item .blog-post-card');
    if (blogPostCard && blogPostCard.length > 0) {
        blogPostCard.forEach((blogPost) => {
            const blogImageLink = blogPost.querySelector('.blog-post-card__image-container a');
            if (blogImageLink) {
                blogImageLink.removeAttribute('href');
                renameElementTag(blogImageLink, 'div');
            }
            const contantLink = blogPost.querySelector('.blog-post-card__content a');
            if (contantLink) {
                contantLink.removeAttribute('href');
                renameElementTag(contantLink, 'div');
            }
        });
    }

    // issue 67
    const featureBlog_heading = document.querySelectorAll('.featured-blog_heading rte-formatter h4');
    if (featureBlog_heading && featureBlog_heading.length > 0) {
        featureBlog_heading.forEach((heading) => {
            heading.setAttribute('aria-level', '2');
        });
    }

    const discoverMoreH = document.querySelectorAll('.group-block-content .findH2.rte h3');
    if (discoverMoreH && discoverMoreH.length > 0) {
        discoverMoreH.forEach((heading) => {
            heading.setAttribute('aria-level', '2');
        });
    }
    
    // issue 68,69,70,71,72,73
    if (window.location.href.includes('/pages/stores')) {
        const filterClearBtn = document.getElementById('bss-clear-filter');
        if (filterClearBtn) {
            filterClearBtn.setAttribute('role', 'button');
            filterClearBtn.setAttribute('tabindex', '0');
        }
         filterClearBtn.addEventListener("keydown", function (e) {
            if (e.key === "Enter" || e.key === " ") {
            e.preventDefault(); // Space press এ page scroll বন্ধ করবে
            handleClearFilter();
            }
        });

        const bssNumbersOfStores = document.getElementById('bss-numbers-of-stores');
        if (bssNumbersOfStores) {
            bssNumbersOfStores.setAttribute('role', 'status');
            bssNumbersOfStores.setAttribute('aria-live', 'polite');
        }

        const bssCheckboxs = document.querySelectorAll('.check-wrapper > input[type="checkbox"]');
        const bssResult = document.querySelector('#bss-search-result');
        function addDynamicAlt(bssResult) {
           // console.log(bssResult);
            for (let i = 0; i < bssResult.children.length; i++) {
                const bssImg = bssResult.children[i].querySelector('.bss-store-image img');
                const bsHeading = bssResult.children[i].querySelector(`#bss-store-name-${i}`);
                if (bssImg && bsHeading) {
                    bssImg.setAttribute('alt', bsHeading.textContent.trim());
                }
            }

        }
        addDynamicAlt(bssResult);
        
        function updateLiveRegion() {
            const anyChecked = Array.from(bssCheckboxs).some(checkbox => checkbox.checked);

            if (anyChecked) {
                bssResult.removeAttribute('role');
                bssResult.removeAttribute('aria-live');
                addDynamicAlt(bssResult);
                
            } else {
                bssResult.setAttribute('role', 'status');
                bssResult.setAttribute('aria-live', 'polite');
            }
        }
        bssCheckboxs.forEach((checkbox) => {
            checkbox.addEventListener('change', updateLiveRegion);
        }); 
        const buttonSearch = document.getElementById('bss-search-btn'); 
        if (buttonSearch) {
            buttonSearch.setAttribute('tabindex', '-1');
        } 
        const bssHeading1 = document.querySelector('.findH2.text-block.h2 > h2');
        const bsssHeading2 = document.querySelector('#bss-wrapper-country > p');
        if (bssHeading1 && bsssHeading2) {
            renameElementTag(bssHeading1, 'h1');
            bsssHeading2.setAttribute('aria-level', '2');
            bsssHeading2.setAttribute('role', 'heading');
        }
    }
    
    // issue 75
    if (window.location.href.includes('/pages/high-jewelry-mood-necklace')) {
        const headingH2 = document.querySelectorAll('.findH2.text-block.h3 p, .findH2.text-block.h3 h6');
        console.log(headingH2)
        if (headingH2 && headingH2.length > 0) {
            renameElementTag(headingH2[0], 'h1');
            renameElementTag(headingH2[1], 'h2');
            renameElementTag(headingH2[2], 'h2');
        }
    }

    // issue 76
    if (window.location.href.includes('/pages/find-your-mood')) {
        const emtyImgAlt = document.querySelectorAll('.image-block.size-style img');
        if (emtyImgAlt && emtyImgAlt.length > 0) {
            emtyImgAlt[0].setAttribute('role', 'presentation');
            emtyImgAlt[1].setAttribute('role', 'presentation');
        }
        const firstHeading = document.querySelector('.findH2.text-block.h3 > h2');
        if (firstHeading) {
            renameElementTag(firstHeading, 'h1');
        }

    }

    // issue 86 
    if (window.location.href.includes('/products/monday-morning-mood-bangle-in-rose-gold')) {
        const headingH2 = document.querySelectorAll('.section-resource-list__content .findH2 h3, .section-resource-list__content .findH2 p');
       // console.log();
        if (headingH2 && headingH2.length > 0) {
            headingH2.forEach((heading) => {
                renameElementTag(heading, 'h2');
            });
        }
        const emtyH5 = document.querySelector('.group-block-content .findH2 h5');
        if (emtyH5) {
            emtyH5.style.visibility = "hidden"
        }
        const productDetHeading = document.querySelectorAll('.shopify-block .findH2.h3 h3, .shopify-block .findH2.h3 p');
        if (productDetHeading && productDetHeading.length > 0) {
            productDetHeading.forEach((heading) => {
                renameElementTag(heading, 'h2');
            });
        }
        const productCardHeading = document.querySelectorAll('.product-card .findH2 > p, .product-card .findH2 > h1');
        if (productCardHeading && productCardHeading.length > 0) {
            productCardHeading.forEach((heading) => {
                 renameElementTag(heading, 'h3');
            });
        }
    }

    if (window.location.href.includes('/profile')) {
        const wrongName = document.querySelector('#profile-details ._1fragem32._1fragemn2');
       // console.log(wrongName);
        if (wrongName) {
            wrongName.removeAttribute('aria-label');
        }
    }

    if (window.location.href.includes('/cart')) {
        const lernMOre = document.querySelector('.findH2 a[href="/pages/warranty"], .findH2 a[href="https://us.nouvelheritage.com/pages/warranty"]');
        if (lernMOre) {
            lernMOre.removeAttribute('title');
            lernMOre.setAttribute('aria-label', window.location.href.includes('fr') ? "En savoir plus sur la garantie et l'authenticité (ouvre dans un nouvel onglet)" : 'Learn more about Warranty & Authenticity Opens in a new tab' );
        }
        const cartLinks = document.querySelectorAll('.cart-items__media > a.cart-items__media-container');
        if (cartLinks && cartLinks.length > 0) {
            cartLinks.forEach((link) => {
                addLinkAria(link);
            });
        } 
        
    }
    
    
    // 124 screen reader announcer for remove button
    document.addEventListener('click', function (event) {
        const removeButton = event.target.closest('.cart-items__remove');
        if (!removeButton) return;

        const hiddenTextEl = removeButton.querySelector('.visually-hidden');
        if (!hiddenTextEl) return;

        const textToAnnounce = hiddenTextEl.textContent.trim();

        const liveRegion = document.getElementById('sr-announcer');
        if (!liveRegion) return;

        // Clear first to force re-announce
        liveRegion.textContent = '';

        setTimeout(() => {
            liveRegion.textContent = window.location.href.includes('fr') ? 'Article retiré du panier.' : ' item removed from cart.';
        }, 100);
    });

    // document.addEventListener('click', function (event) {
    //     const removeButton = event.target.closest('.cart-items__remove');
    //     if (!removeButton) return;

    //     // Try visually-hidden first
    //     let textToAnnounce = '';

    //     const hiddenTextEl = removeButton.querySelector('.visually-hidden');

    //     if (hiddenTextEl) {
    //         textToAnnounce = hiddenTextEl.textContent.trim();
    //     } else if (removeButton.getAttribute('aria-label')) {
    //         textToAnnounce = removeButton.getAttribute('aria-label');
    //     } else {
    //         textToAnnounce = 'Item';
    //     }

    //     const liveRegion = document.getElementById('sr-announcer');
    //     if (!liveRegion) return;

    //     // Force re-announce
    //     liveRegion.textContent = '';

    //     setTimeout(() => {
    //         liveRegion.textContent = `${textToAnnounce} removed from cart.`;
    //         liveRegion.textContent = '';
    //     }, 100);
    // });


// Fix localization form - prevent ESC from closing dropdown when language select is focused
    const languageSelects = document.querySelectorAll('select[name="language_code"]');
    if (languageSelects && languageSelects.length > 0) {
        languageSelects.forEach((languageSelect) => {
            // Prevent ESC key from bubbling up to parent dropdown
            languageSelect.addEventListener('keydown', function(event) {
                if (event.key === 'Escape' || event.key === 'Esc') {
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                }
            });
            
            languageSelect.addEventListener('keyup', function(event) {
                if (event.key === 'Escape' || event.key === 'Esc') {
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                }
            });
        });
    }

    if (window.location.href.includes('blogs/how-they-wear-it')) {
        const blogHeadin2 = document.querySelectorAll('.blog-post-card__content h2.findH2');
        if (blogHeadin2 && blogHeadin2.length > 0) {
            blogHeadin2.forEach((heading) => {
                heading.classList.add('customHeaderColorADD');
            });
        }
    }


    const emailHeadin1 = document.querySelector('#rich-text-01K9FRSDQDT8TENSVV8BWTNF6M h2');
    if (emailHeadin1) {
        renameElementTag(emailHeadin1, 'h1');
    }

    const heroVideos = document.querySelectorAll(".hero__media");
    heroVideos.forEach(function(video){
        const wrapper = video.parentElement;

        wrapper.classList.add("hero-video-wrapper");

        // create button
        const btn = document.createElement("button");
        btn.className = "hero-video-control-btn";
        btn.setAttribute("aria-label","Pause video");

        btn.innerHTML = "▶";

        wrapper.appendChild(btn);

        // if autoplay running hide button
        if(!video.paused){
        btn.style.display="none";
        btn.textContent = "▶";
        }
        if(video.paused){
        btn.textContent = "❚❚";
        }

        // button click
        btn.addEventListener("click", function(){
            console.log("click");   
        if(video.paused){

        video.play();
        btn.textContent = "❚❚";
        btn.setAttribute("aria-label","Pause video");
        }else{

        video.pause();
        btn.textContent = "▶";
        btn.setAttribute("aria-label","Play video");

        }

        });
     });

    //www.nouvelheritage.com/?_ab=0&_fd=0&_sc=1&preview_theme_id=141545275469

    // https://nouvel-heritage.myshopify.com/?preview_theme_id=141543080013
    console.log("a11y run");
//   }, 5000);
});

